import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './CustomEditor.css';
const CustomEditor = (props) => {
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const editorClass = `${props.className} ${isFocused ? 'focused' : ''}`;
    const onFocusText = () => {
        setIsFocused(true);
    };
    return (
        <>
            <ReactQuill
                placeholder={props.placeholder}
                className={editorClass}
                onFocus={handleFocus}
                onBlur={handleBlur}
                theme="snow"
                value={props.value}
                onChange={props.onChange}
            />
            <div
                onClick={onFocusText}
                style={{ display: isFocused ? 'none' : 'block' }}
                className="editor-view-container"
            >
                <div dangerouslySetInnerHTML={{ __html: props.value }} />
            </div>
        </>
    );
};

export default CustomEditor;
